import React from 'react';

import { formatValue } from '../../base/common/utils';

const TrendTotals = ({ type, data }) => {
  let summaries;

  const formatNum = (count, type = 'number') => {
    const abbreviations = ['', 'K', 'M', 'B', 'T', 'P', 'E', 'Z', 'Y'];
    const decimalIndex = count === 0 ? count : Math.floor(Math.log(count) / Math.log(1000));
    let result = parseFloat((count / 1000 ** decimalIndex).toFixed(1));
    result += `${abbreviations[decimalIndex]}`;

    if (type === 'currency') {
      return `$${result}`;
    }
    return result;
  };

  if (type === 'cart-explorer') {
    const stats = data && data.stats_summary ? data.stats_summary : null;
    summaries = {
      'Total Orders': stats && stats.total_orders ? formatNum(stats.total_orders) : '-',
      'Total Transactions':
        stats && stats.total_transactions ? formatNum(stats.total_transactions, 'currency') : '-',
      'Total Products': stats && stats.total_products ? formatNum(stats.total_products) : '-',
    };
  } else if (type === 'search-trends') {
    summaries = {
      'Search Terms': data.total_items ? formatValue(data.total_items, 'number') : '-',
      Searches: data.total_searches ? formatValue(data.total_searches, 'number') : '-',
    };
  }

  const statSummaries = summaries
    ? Object.keys(summaries).map(key => {
        return (
          <div key={key} className={`totals ${key.replace(' ', '-').toLowerCase()}`}>
            <div className="label">{key}</div>
            <div className="value">{summaries[key]}</div>
          </div>
        );
      })
    : null;

  let summaryHeader;
  if (type === 'product-research') {
    const stats = data && data.stats_summary ? data.stats_summary : null;
    const totalTransactions =
      stats && stats.total_transactions && formatNum(stats.total_transactions, 'currency');
    let formattedTotal = totalTransactions;
    // Add a space between the value and magnitude (e.g '8.4 M')
    if (totalTransactions && /[a-zA-Z]/g.test(totalTransactions[totalTransactions.length - 1])) {
      const magnitude = ` ${totalTransactions[totalTransactions.length - 1]}`;
      formattedTotal = `${totalTransactions.slice(0, totalTransactions.length - 1)}${magnitude}`;
    }
    summaryHeader = formattedTotal ? (
      <div>
        <span>Browse the data from</span>
        <span className="total-transactions">{formattedTotal}</span>
        <span>
          {`total transactions we've aggregated from our e-commerce partners,
					including outside the Narrativ ecosystem.`}
        </span>
      </div>
    ) : null;
  }

  return (
    <div className="trend-totals">
      {summaryHeader}
      {statSummaries}
    </div>
  );
};

export default TrendTotals;
